import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../api";
import StudentView from "../components/StudentView";

export default function FamilyDashboard() {
  const [students, setStudents] = useState(null);
  const [selected, setSelected] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/family/students")
      .then(({ data }) => {
        setStudents(data);
        setSelected(data[0] || null);
      })
      .catch((ex) => setErr(formatApiError(ex)));
  }, []);

  if (err) return <div className="text-[#9B2C3B] text-[13px]">{err}</div>;
  if (!students) return <div className="text-[13px] text-[#132C44]/60">Cargando…</div>;

  return (
    <div className="space-y-6" data-testid="eid-family-dashboard">
      <div>
        <span className="inline-block text-[10px] font-semibold tracking-widest text-[#4F6B47] px-2 py-1 border border-[#4F6B47]/30 rounded-full">
          ACCESO FAMILIAR
        </span>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-bold">Seguimiento académico</h1>
        <p className="mt-1 text-[13px] text-[#132C44]/65">
          Información publicada por Pinar English Academy. Solo lectura.
        </p>
      </div>

      {students.length === 0 && (
        <p className="text-[13px] text-[#132C44]/70" data-testid="eid-family-empty">
          No hay alumnos vinculados a tu cuenta. Consultá con la academia.
        </p>
      )}

      {students.length > 1 && (
        <div className="flex gap-2 flex-wrap" data-testid="eid-family-student-picker">
          {students.map((s) => (
            <button
              key={s.id}
              onClick={() => setSelected(s)}
              className={`px-4 py-2 rounded-full text-[13px] font-semibold border transition-colors ${
                selected?.id === s.id ? "bg-[#8AA986] border-[#8AA986] text-[#132C44]" : "bg-white border-[#132C44]/15"
              }`}
              data-testid={`eid-family-pick-${s.studentCode}`}
            >
              {s.firstName} {s.lastName}
            </button>
          ))}
        </div>
      )}

      {selected && (
        <div key={selected.id} className="space-y-4">
          <h2 className="font-serif text-2xl font-bold" data-testid="eid-family-student-name">
            {selected.firstName} {selected.lastName}
          </h2>
          <StudentView student={selected} ownerLabel="Su" />
        </div>
      )}
    </div>
  );
}
